import settings from "./settings.json";

export default function () {
    return settings.ENVIRONMENTS.find(function (env) {
        return env.hostname == window.location.hostname;
    });
}